import { useEffect, useRef, useState, useMemo, createRef } from 'react';
import styles from './Columns.module.css';
import { Player } from '@lordicon/react';
import ScrollReveal from 'scrollreveal';
// האייקונים הקיימים
import phone from "../../icons/wired-outline-140-earphone-telephone-hover-calling.json"
import dohot from "../../icons/wired-outline-3138-customer-insights-alt-hover-pinch.json"
import invoice from "../../icons/wired-outline-2450-invoice-general-hover-swipe.json"
import diary from "../../icons/wired-outline-973-appointment-schedule-hover-click.json"
import mails from "../../icons/wired-outline-959-internet-hover-rotate.json"
import foryou from "../../icons/wired-outline-1846-employee-working-hover-working (1).json"
import recrew from "../../icons/wired-outline-1846-employee-working-hover-working (1).json"
import organization from "../../icons/wired-outline-969-meeting-conference-room-hover-pinch.json"
import money from "../../icons/wired-outline-799-credit-card-morph-terminal.json"
import typing from "../../icons/wired-outline-747-keyboard-hover-pinch.json"
import Button from '../button/Button';


const PlayerColumns = () => {

    // נתוני הקטגוריות עם השירותים שלהם
    const categoriesData = useMemo(() => [
        {
            icon: phone,
            title: "שירותי מזכירות",
            services: [
                "מענה טלפוני אישי",
                "ניהול יומן פגישות - תיאום מלא ושירות תזכורות",
                "ניהול הזמנות עבודה על גבי דוחות",
                "ניהול מיילים ופקסים",
                "הקלדת מסמכים - סיכומי ישיבות, פרזנטציות, דוחות ומכתבים"
            ]
        },
        {
            icon: money,
            title: "גבייה והפקת חשבוניות",
            services: [
                "יצירת קשר עם חייבים ותיאום העברת תשלומים",
                "עדכון שוטף וניהול גבייה בקובץ ייעודי",
                "הפקת דוחות מעקב על הוצאות והכנסות העסק",
                "הפקת חשבוניות ממוחשבות",
                "שליחת חשבוניות וקבלות במייל",
                "ניהול מול ספקים, רואי חשבון ולקוחות"
            ]
        },
        {
            icon: dohot,
            title: "סקרי שוק, בנייה והפקת דוחות",
            services: [
                "עריכת סקרי שוק והשוואת מחירי מתחרים",
                "ריכוז הצעות מחיר ומעקב לסגירת טיפול",
                "בנייה ועדכון דוחות סטטיסטיים",
                "דוחות קבלת משוב לאחר מתן שירות",
                "דוח מרכז על פרויקטים והתקדמותם"
            ]
        },
        {
            icon: organization,
            title: "ניהול קשרי לקוחות",
            services: [
                "הקמה ובניית מאגר לקוחות ועדכון שוטף",
                "ניהול קשר רציף עם לקוחות",
                "שליחת מידע על מבצעים, חגים וימי הולדת",
                "* העבודה מתבצעת על מערכות הלקוח"
            ]
        },
        {
            icon: foryou,
            title: "ניהול עובדים וכ\"א",
            services: [
                "מעקב עבודה יומי של עובדים",
                "ריכוז שעות עבודה והעברת סיכומים חודשיים",
                "פרסום משרות ברשתות ובחברות כ\"א",
                "סינון ראשוני של מועמדים"
            ]
        },
        {
            icon: organization,
            title: "תיאומים עסקיים ופרטיים",
            services: [
                "ארגון ישיבות, ימי עיון, סדנאות וכנסים",
                "הכנת חומרים ומצגות",
                "תיאום טכני ולוגיסטי - מקום, ציוד, כיבוד, הסעות",
                "הזמנת כרטיסי טיסה ושהייה",
                "תיאום פגישות אישיות והגשת מסמכים לרשויות",
                "פעולות שוטפות מול הבנק ובעלי מקצוע"
            ]
        },
    ], []);

    // יצירת מערך דינמי של Refs לכל הקטגוריות
    const playerRefs = useRef(categoriesData.map(() => createRef()));
    const [activeColumns, setActiveColumns] = useState({});

    // שימוש ב-useEffect להפעלת האנימציה בהתחלה
    useEffect(() => {
        playerRefs.current.forEach(ref => {
            if (ref.current) {
                ref.current.playFromBeginning();
            }
        });
        
        ScrollReveal().reveal(`.${styles.icon}`, {
            duration: 1000,
            distance: "30px",
            origin: "top",
            easing: "ease-out",
            reset: false,
            viewFactor: 0.2,
            interval: 300,
            delay: 200,
            scale: 1,
        });
    }, []);

    // פונקציה להפעלה חוזרת של האנימציה
    const handleComplete = (index) => {
        setTimeout(() => {
            const ref = playerRefs.current[index];
            if (ref && ref.current) {
                ref.current.playFromBeginning();
            }
        }, 2500);
    };

    const toggleColumn = (index) => {
        setActiveColumns(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // חלוקה לשורות של 3
    const rows = [];
    for (let i = 0; i < categoriesData.length; i += 3) {
        rows.push(categoriesData.slice(i, i + 3));
    }

    return (
        <>
            <div className={styles.title} id="שירותי המשרד">שירותי המשרד</div>
            <div className={styles.subtitle}>לחצו על כל שירות כדי לראות מה הוא כולל</div>
            <div className={styles.mainContainer}>
                {rows.map((row, rowIndex) => (
                    <div key={rowIndex} className={styles.row}>
                        {row.map((category, colIndex) => {
                            const categoryIndex = rowIndex * 3 + colIndex;
                            return (
                                <div key={categoryIndex} className={styles.column}>
                                    <div 
                                        className={`${styles.cardContent} ${activeColumns[categoryIndex] ? styles.active : ''}`}
                                        onClick={() => toggleColumn(categoryIndex)}
                                    >
                                        <div className={styles.icon}>
                                            <Player
                                                icon={category.icon}
                                                ref={playerRefs.current[categoryIndex]}
                                                size="95%"
                                                colorize='white'
                                                loop={true}
                                                onComplete={() => handleComplete(categoryIndex)}
                                            />
                                        </div>
                                        <div className={styles.textContainer}>
                                            <p className={styles.text}>{category.title}</p>
                                            <div className={`${styles.arrow} ${activeColumns[categoryIndex] ? styles.arrowActive : ''}`}>
                                                ▼
                                            </div>
                                        </div>
                                        <div className={`${styles.pointsWrapper} ${activeColumns[categoryIndex] ? styles.pointsVisible : ''}`}>
                                            <div className={styles.pointsContainer}>
                                                {category.services.map((service, serviceIndex) => (
                                                    <div 
                                                        key={serviceIndex} 
                                                        className={styles.point}
                                                        style={{ 
                                                            animationDelay: `${serviceIndex * 0.1}s`,
                                                            opacity: activeColumns[categoryIndex] ? 1 : 0,
                                                            transform: activeColumns[categoryIndex] ? 'translateY(0)' : 'translateY(10px)'
                                                        }}
                                                    >
                                                        <span className={styles.bullet}>●</span>
                                                        <span className={styles.pointText}>{service}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
            <Button text="קרן בואי נדבר!"/>
        </>
    );
};

export default PlayerColumns;